var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/ecs-log-formatter.ts
function getUrlField(logRecord) {
  const original = logRecord.request?.url;
  const domain = logRecord.request?.domain;
  if (!original || !domain) return;
  return { original, domain };
}
__name(getUrlField, "getUrlField");
function getHttpField(logRecord) {
  if (!logRecord.request) return;
  return {
    "request.referrer": logRecord.request.referrer,
    "request.method": logRecord.request.method,
    "response.status_code": logRecord.request.statusCode
  };
}
__name(getHttpField, "getHttpField");
var EcsLogFormatter = class {
  constructor(config) {
    this.config = config;
  }
  static {
    __name(this, "EcsLogFormatter");
  }
  format(logRecord) {
    return {
      "@timestamp": logRecord.timestamp,
      "service": {
        name: this.config.serviceName
      },
      "message": logRecord.message,
      "log": {
        ...logRecord.logLevel && { level: logRecord.logLevel },
        logger: logRecord.logger
      },
      "user_agent": logRecord.userAgent !== void 0 ? {
        original: logRecord.userAgent
      } : void 0,
      "event": logRecord.duration !== void 0 ? {
        duration: logRecord.duration
      } : void 0,
      "transaction": logRecord.transactionId !== void 0 ? {
        id: logRecord.transactionId
      } : void 0,
      "trace": logRecord.traceId !== void 0 ? {
        id: logRecord.traceId
      } : void 0,
      "url": getUrlField(logRecord),
      "http": getHttpField(logRecord),
      "source": logRecord.ip !== void 0 ? {
        ip: logRecord.ip
      } : void 0,
      "error": logRecord.error ? {
        message: logRecord.error.message,
        stack_trace: logRecord.error.stackTrace
      } : void 0,
      "labels": logRecord.meta ? logRecord.meta : void 0
    };
  }
};
export {
  EcsLogFormatter
};
//# sourceMappingURL=index.mjs.map